const UPDATE_LANGUAGE = "update";
const CHANGE_DEFAULT = "default";
const SET_ON_LOAD = "onLoad";

export { UPDATE_LANGUAGE, CHANGE_DEFAULT, SET_ON_LOAD };
